<template>
  <div :class="['le-loader']" :style="loaderStyle" :aria-label="loadingLabel"></div>
</template>

<script>
  export default {
    name: 'le-loader',
    props: {
      size: {
        type: Number,
        required: true,
      },
      loadingLabel: {
        type: String,
        default: 'Loading',
      },
    },
    computed: {
      loaderStyle() {
        return {
          fontSize: `${this.size}px`,
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .le-loader {
    border-radius: 50%;
    width: 1em;
    height: 1em;
    @include themify {
      border: 0.1em solid getColor('text');
      border-left-color: transparent;
    }
    @include transform-translateZ(0);
    -webkit-animation: loaderAnimation 1.1s infinite linear;
    animation: loaderAnimation 1.1s infinite linear;
  }
  @-webkit-keyframes loaderAnimation {
    0% {
      @include transform-rotate(0deg);
    }
    100% {
      @include transform-rotate(360deg);
    }
  }
  @keyframes loaderAnimation {
    0% {
      @include transform-rotate(0deg);
    }
    100% {
      @include transform-rotate(360deg);
    }
  }
</style>
